export const extractHashTags = (hashtags, text) => {
  let newText = text;
  if (hashtags) {
    hashtags.forEach((index) => {
      newText = text.replace(/#[\w]+/g, `#${index}`);
    });
  }
  return newText;
};

export const findHashTag = (contents, label) => {
  const results = [];

  contents.forEach((content) => {
    const regex = new RegExp(`${label}`, "i");
    const result = content.tags.find((hashtag) => regex.test(hashtag));
    if (result) {
      let indexTag = 0;
      const isExisting = results.some((hashtag, index) => {
        indexTag = index;
        return hashtag.tag === result;
      });
      if (isExisting) {
        results[indexTag] = {
          ...results[indexTag],
          numberContent: results[indexTag].numberContent + 1,
        };
      } else {
        results.push({ tag: result, numberContent: 1 });
      }
    }
  });

  console.log("Haaaaaaaaaaaaaaaaaaaaaaas", {
    contents,
    results,
  });

  return results;
};
